export default __webpack_public_path__ + "static/media/bluedots.b01934cf.png";